



























































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { finance, FinanceService } from '@/api'
import FinanceHistoryList from './FinanceHistoryList.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import FinancePayList from './FinancePayList.vue'
import FinanceCalendar from './FinanceCalendar.vue'

@Component({ components: { FinanceHistoryList, PulseLoader, FinancePayList, FinanceCalendar } })
export default class Finance extends Vue {
  public data!: finance
  public loaded = false

  mounted (): void {
    FinanceService.getFinance().then(data => {
      this.data = data
    }).finally(() => {
      this.loaded = true
    })
  }
}
